import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 160 160"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00B388",
      fillRule: "evenodd",
      d: "M80 0c16.768 0 31.601 1.359 40.624 3.441 17.992 3.776 32.159 17.943 35.935 35.935C158.641 48.399 160 63.232 160 80s-1.359 31.601-3.441 40.624c-3.776 17.992-17.943 32.159-35.935 35.935C111.601 158.641 96.768 160 80 160s-31.601-1.359-40.624-3.441c-17.992-3.776-32.16-17.943-35.935-35.935C1.36 111.601 0 96.768 0 80s1.359-31.601 3.441-40.624C7.217 21.384 21.384 7.216 39.376 3.44 48.399 1.36 63.232 0 80 0m10.534 115.266a12.09 12.09 0 0 1 8.637 7.152c.05.119.103.262.157.416.316.913 1.184 1.536 2.146 1.451.602-.054 1.243-.112 1.683-.156 6.249-.624 11.16-1.494 14.015-2.51l.017-.007a5.076 5.076 0 0 0 3.264-5.18l-.004-.037-.002-.024a2 2 0 0 1-.01-.165c-.487-6.525-4.442-21.802-10.348-39.238-6.753-19.934-13.814-36.072-16.999-39.22l-.004-.005a6.8 6.8 0 0 0-1.739-1.311 5.6 5.6 0 0 0-.954-.414l-.034-.012c-2.088-.708-5.944-1.182-10.363-1.182-4.411 0-8.267.474-10.36 1.183l-.03.01q-.572.197-.953.415a6.8 6.8 0 0 0-1.743 1.317c-3.185 3.147-10.246 19.285-16.999 39.219-5.906 17.436-9.861 32.713-10.348 39.238a2 2 0 0 1-.016.226l-.015.268-.003.162a5.075 5.075 0 0 0 3.282 4.75l.017.007c2.857 1.017 7.775 1.887 14.031 2.512.438.043 1.072.101 1.67.154.96.085 1.83-.536 2.145-1.447a8 8 0 0 1 .188-.497 12.09 12.09 0 0 1 8.604-7.075c2.34-.541 6.186-.895 10.534-.895s8.194.354 10.534.895",
      clipRule: "evenodd"
    }
  )
);
var SvgLogoMarkColor = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LogoMarkColor_default = SvgLogoMarkColor;

export { LogoMarkColor_default as default };
